import { render, staticRenderFns } from "./RsaPazienteRiepilogoOperatoriListPage.vue?vue&type=template&id=463713ae"
import script from "./RsaPazienteRiepilogoOperatoriListPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteRiepilogoOperatoriListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports